@if(isVisible()){
<div [id]="navLink.id" class="udex-grid udex-mx-auto udex-mb-32 udex-lg-mb-0">
  <div class="hero-section">

    <div class="d-lg-none">
      <dcp-product-name-display></dcp-product-name-display>
    </div>

    <div>
      @if(summary){
      <h2 class="heading__regular--l udex-mb-16">{{ summary }}</h2>
      }

      @if(product){
      <dcp-hero-review [product]="product" class="my-3"></dcp-hero-review>
      }

      @if(description){
      <dcp-limited-text class="d-block udex-mb-16" [charLimit]="300" [text]="description">
      </dcp-limited-text>
      }

      <dcp-cta-form [isHeroSection]="true" class="flex-grow-0">
      </dcp-cta-form>
    </div>

    <dcp-classifications-template [parentHeroComponent]="true" [productClassifications]="productClassifications"
      [product]="product">
    </dcp-classifications-template>


    @if(gallery.length){
    <div class="hero-section__product-media d-flex justify-content-lg-center flex-column">
      <div class="hero-gallery-container">
        <div class="hero-gallery-mobile-overlay d-lg-none"></div>
        <dcp-media [media]="gallery[galleryIndex]" class="text-center"></dcp-media>

        @if (gallery.length > 1) {
        <udex-button class="d-block arrow-left navigation-button" icon="slim-arrow-left" icon-only design="Primary"
          accessible-role="Button" accessible-name="Previous" size="Large" (click)="showPreviousGalleryItem()">
        </udex-button>
        <udex-button class="d-block arrow-right navigation-button" icon="slim-arrow-right" icon-only design="Primary"
          accessible-role="Button" accessible-name="Next" size="Large" (click)="showNextGalleryItem()">
        </udex-button>
        }
      </div>

      @if(!hasContent){
      <dcp-classifications-template [parentHeroComponent]="true" [productClassifications]="productClassifications"
        [product]="product">
      </dcp-classifications-template>}

    </div>
    }
  </div>

</div>
}

<div class="udex-legacy-shadow d-none d-lg-block udex-my-32"></div>
